import { MenuProfileIds } from "@core/layout/components/top-bar/components/menu-profile/enums/menu-profile-ids.enum";
import { ClientDroits } from "@jack-sparrow-libraries/emotion-models";

export class MenuProfileUtils {
	private static readonly MENU_PROFILE_IDS_PS: MenuProfileIds[] = [
		MenuProfileIds.PROFIL,
		MenuProfileIds.PROFIL_AGATHE_YOU,
		MenuProfileIds.PROFIL_OPALINE,
		MenuProfileIds.ESPACE_CLIENT,
		MenuProfileIds.PREFERENCES,
		MenuProfileIds.PREFERENCES_MON_LECTEUR,
		MenuProfileIds.PREFERENCES_MES_SOINS_FAVORIS,
		MenuProfileIds.PREFERENCES_AUTRES,
		MenuProfileIds.FORMATION,
		MenuProfileIds.FORMATION_FAQ,
		MenuProfileIds.FORMATION_TUTOS,
		MenuProfileIds.LIENS_UTILS,
		MenuProfileIds.LIENS_UTILS_PRESCRIPTEURS,
		MenuProfileIds.LIENS_UTILS_CAISSES,
		MenuProfileIds.LIENS_UTILS_NOMENCLATURE,
		MenuProfileIds.LIENS_UTILS_CONVENTIONNEMENT,
		MenuProfileIds.LIENS_UTILS_AMELI_PRO,
	] as const;

	private static readonly MENU_PROFILE_IDS_REMPLACANT: MenuProfileIds[] = [
		MenuProfileIds.PROFIL,
		MenuProfileIds.PROFIL_AGATHE_YOU,
		MenuProfileIds.PREFERENCES,
		MenuProfileIds.PREFERENCES_MON_LECTEUR,
	] as const;

	private static readonly MENU_PROFILE_IDS_ADMIN: MenuProfileIds[] = [
		MenuProfileIds.PROFIL,
		MenuProfileIds.PROFIL_AGATHE_YOU,
		MenuProfileIds.PROFIL_OPALINE,
		MenuProfileIds.ESPACE_CLIENT,
		MenuProfileIds.PREFERENCES,
		MenuProfileIds.PREFERENCES_MON_LECTEUR,
		MenuProfileIds.PREFERENCES_MES_SOINS_FAVORIS,
		MenuProfileIds.PREFERENCES_AUTRES,
		MenuProfileIds.FORMATION,
		MenuProfileIds.FORMATION_FAQ,
		MenuProfileIds.FORMATION_TUTOS,
		MenuProfileIds.LIENS_UTILS,
		MenuProfileIds.LIENS_UTILS_PRESCRIPTEURS,
		MenuProfileIds.LIENS_UTILS_CAISSES,
		MenuProfileIds.LIENS_UTILS_NOMENCLATURE,
		MenuProfileIds.LIENS_UTILS_CONVENTIONNEMENT,
		MenuProfileIds.LIENS_UTILS_AMELI_PRO,
		MenuProfileIds.GESTION_ADMINISTRATION,
		MenuProfileIds.GESTION_ADMINISTRATION_ADMIN,
		MenuProfileIds.GESTION_ADMINISTRATION_MARKETING,
		MenuProfileIds.GESTION_ADMINISTRATION_DEV,
	] as const;

	static getIdsByClientDroits(droits: ClientDroits) {
		if (
			droits === ClientDroits.Remplacant_Sans_Acces_Donnees ||
			droits === ClientDroits.Remplacant_Acces_Personnalise
		) {
			return this.MENU_PROFILE_IDS_REMPLACANT;
		} else if (droits >= ClientDroits.Marketing) {
			if (droits < ClientDroits.Hotliner) {
				return this.MENU_PROFILE_IDS_ADMIN.filter((item) => {
					return (
						item !== MenuProfileIds.GESTION_ADMINISTRATION_ADMIN &&
						item !== MenuProfileIds.GESTION_ADMINISTRATION_DEV
					);
				});
			} else if (droits === ClientDroits.SuperAdmin) {
				return this.MENU_PROFILE_IDS_ADMIN;
			} else {
				return this.MENU_PROFILE_IDS_ADMIN.filter((item) => item !== MenuProfileIds.GESTION_ADMINISTRATION_DEV);
			}
		}
		return this.MENU_PROFILE_IDS_PS;
	}
}
